/*
 * File: AddUsers.styles.js
 * Project: lets-talk-web
 *
 * Copied from Profile.styles.js
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { Padding, Button } from '../../../components';

// Constants
import { mobileBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled(Padding)`
	position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 40px;
    padding-bottom: 40px;
`;

export const Decoration = styled.div`
	position: absolute;
	z-index: 1;
	width: 100%;
	min-height: 70vw;
	height: 100vh;
	left: 0px;
	top: 0px;
	background-image: url('${process.env.CDN_URL}/public/assets/decorations/green-bump-decoration.png');
	background-size: cover;
	background-position: 50% 0%;
	background-repeat: no-repeat;
`;

export const TitleWidget = styled.div`
	width: 100%;
	height: 62px;
	border-radius: 100px;
	border: 2px solid ${({ theme }) => theme.brandSecondaryBaseDarker};
	display: flex;
	align-items: center;
	z-index: 2;
	flex-shrink: 0;

	h4 {
		color: ${({ theme }) => theme.brandSecondaryBaseDarker};
		text-align: left;
		margin-left: 30px;
	}
`;

export const ContentContainer = styled.div`
	height: auto;
    z-index: 2;
    padding: 16px 0;
`;

export const Header = styled.div`
	margin: 30px 0px 0px;
	width: 100%;
	max-width: 100%;

	* {
		text-align: left;
		line-height: 1.6;
	}
	@media only screen and (min-width: ${mobileBreakpoint}em) {
		max-width: 75%;
	}
`;

export const ActionButton = styled(Button)`
	margin: 0px;
`;

export const RadioGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 16px 0;
`;

export const GroupLabel = styled.label`
    font-weight: 500;
    margin-bottom: 4px;
`;

export const RadioLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
`;
